export default __webpack_public_path__ + "static/media/MakeOrMiss.bf5e6265.jpg";